import { useEffect, useState } from 'react'
import { Roles } from '@/entities/roles'
import { TopupStatus } from '@/entities/topups'
import { TopupModel, TopupModelMerchant } from '../types'

type UseManualConfirmTimerProps = {
  data: TopupModel | TopupModelMerchant
  userRole: Roles | null
}

export const useManualConfirmTimer = ({ data, userRole }: UseManualConfirmTimerProps) => {
  // Таймер для ручного подтверждения
  const [timeRemaining, setTimeRemaining] = useState<number>(0)

  useEffect(() => {
    if (![TopupStatus.Cancelled, TopupStatus.Timeout].includes(data.status)) return
    if (!data.validTill) return

    const updateTimer = () => {
      const validTill = new Date(data.validTill!)
      const deadline = new Date(validTill.getTime() + 30 * 60 * 1000) // validTill + 30 минут
      const now = new Date()
      const diffMs = deadline.getTime() - now.getTime()

      if (diffMs <= 0) {
        setTimeRemaining(0)
        return
      }

      const minutes = Math.ceil(diffMs / 60000)
      setTimeRemaining(minutes)
    }

    updateTimer()
    const interval = setInterval(updateTimer, 60000) // Каждую минуту

    return () => clearInterval(interval)
  }, [data.status, data.validTill])

  // Проверка доступности ручного подтверждения
  const isManualConfirmAvailable = () => {
    if (userRole === Roles.Merchant) return false
    if (![TopupStatus.Cancelled, TopupStatus.Timeout].includes(data.status)) return false
    if (!data.validTill) return false

    const validTill = new Date(data.validTill!)
    const deadline = new Date(validTill.getTime() + 30 * 60 * 1000) // validTill + 30 минут
    const now = new Date()

    return now >= validTill && now <= deadline && timeRemaining > 0
  }

  return {
    timeRemaining,
    isManualConfirmAvailable
  }
}
